import { mapActions } from 'vuex';
import contentHeader from '@/components/generics/content-header/content-header.vue';
import catchHtmlClickMixin from '@/helpers/catchHtmlClickMixin';
import faq from '@/components/support/faq/faq.vue';
import supportMixin from '@/mixins/support';
import cmsContentMixin from '@/mixins/cmsContent';
import { STATIC_PAGES } from '@/constants';
import staticPageHeader from '@/components/static-page-header/static-page-header.vue';
import { BRAND } from '@/components/brand-name/brand-name.js';
import loaderMixin from '@/mixins/loader';
import contentLoaderMixin from '@/mixins/contentLoader';

const DEFAULT_TITLE = `How to Trade on ${BRAND}`;

export default {
  mixins: [
    catchHtmlClickMixin,
    cmsContentMixin,
    supportMixin,
    loaderMixin,
    contentLoaderMixin,
  ],
  props: {
    title: {
      type: String,
      default: DEFAULT_TITLE,
    },
  },
  components: {
    contentHeader,
    faq,
    staticPageHeader,
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
  },
  metaInfo() {
    return {
      title: 'Support',
    };
  },
  created() {
    this.loaderAdd(document.body);
    this.getStaticPageFull(STATIC_PAGES.HOW_TO_TRADE)
      .then((data) => {
        this.isComponentReady = true;
        this.installDynamicControls({ data });
      }).then(() => this.loaderRemove(document.body))
      .catch(() => this.loaderRemove(document.body));
  },
};



// WEBPACK FOOTER //
// ./src/components/support/learn-the-basics/learn-the-basics.js